var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.params.data.last_adt_correlation_id)?_c('button',{staticClass:"prime-button button-secondary button-block",on:{"click":function($event){return _vm.onClick()}}},[_c('span',{staticClass:"text-black"},[_vm._v(" "+_vm._s(_vm.params.value)+" ")])]):_c('span',[_vm._v(" "+_vm._s(_vm.params.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }